export const REGION_CODE_COOKIE_NAME = 'X-Cf-Request-RegionCode';
export const REGION_CODE_HEADER_NAME = 'X-Cf-Request-RegionCode';
